import { PwaAgenda } from './PwaAgenda';
import { useGreetingName } from './useGreetingName';

/**
 * Inicio de la app mobile: saludo + la agenda (vista diaria, semanal y mensual) en SOLO LECTURA — ver `PwaAgenda`.
 * Lo que se oculta por estar en mobile lo decide `useIsPwaApp()` dentro de los componentes compartidos con la web
 * (Meet, reporte de ausencia, links al Perfil, agendado).
 */
export function PwaInicio() {
  const greetingName = useGreetingName();

  return (
    <main className="mx-auto w-full max-w-3xl px-4 pb-6 pt-4 text-left font-[Poppins,sans-serif]">
      <header className="mb-3 flex flex-col gap-0.5">
        <h1 className="m-0 break-words text-2xl font-semibold text-[#2d2049]">
          {greetingName ? `Hola, ${greetingName} 👋` : 'Hola 👋'}
        </h1>
        <p className="m-0 text-sm text-[#455375]">Tus sesiones</p>
      </header>

      <PwaAgenda />
    </main>
  );
}
